module.exports = __webpack_public_path__ + "94bc492d7684c42a40ed63b756d5d96c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/entrance/assets/bottomBg.png
// module id = 813
// module chunks = 0